'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIListingPage from 'UIComponents/page/UIListingPage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import DashboardNavigation from 'AdsUI/components/DashboardNavigation';

const ErrorMessageWithNavigation = ({
  routes
}) => /*#__PURE__*/_jsx(UIListingPage, {
  headerComponent: /*#__PURE__*/_jsx(DashboardNavigation, {
    routes: routes
  }),
  children: /*#__PURE__*/_jsx(UIErrorMessage, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "errors.genericError"
    })
  })
});

export default withRouter(ErrorMessageWithNavigation);